import React from 'react';
import TimeKeeper from 'react-timekeeper';
import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';

import styles from './index.styl';

function TimePicker({ time, onChange, format }) {
  return (
    <div styleName="root">
      <TimeKeeper
        time={time}
        onChange={data => onChange(data[format])}
        coarseMinutes
      />
    </div>
  );
}

TimePicker.propTypes = {
  time: PropTypes.string,
  onChange: PropTypes.func,
  format: PropTypes.string,
};

TimePicker.defaultProps = {
  format: 'formatted12',
};

export default CSSModules(TimePicker, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/TimePicker/index.jsx